import { Icon, Props } from "./MetadataDownloadIcon.Parts";

export const MetadataDownloadIcon = ({ small, ...props }: Props) => (
  <Icon
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $small={small}
    {...props}
  >
    <path
      d="M13.2802 12.1021H6.26054C6.13013 12.1021 6.02441 12.2078 6.02441 12.3383V13.755C6.02441 13.8854 6.13013 13.9912 6.26054 13.9912H13.2802C13.4106 13.9912 13.5163 13.8854 13.5163 13.755V12.3383C13.5163 12.2078 13.4106 12.1021 13.2802 12.1021Z"
      fill="currentColor"
    />
    <path
      d="M11.3912 5.89562H6.26054C6.13013 5.89562 6.02441 6.00134 6.02441 6.13175V7.54852C6.02441 7.67893 6.13013 7.78465 6.26054 7.78465H11.3912C11.5216 7.78465 11.6273 7.67893 11.6273 7.54852V6.13175C11.6273 6.00134 11.5216 5.89562 11.3912 5.89562Z"
      fill="currentColor"
    />
    <path
      d="M12.3357 8.99887H6.26054C6.13013 8.99887 6.02441 9.10459 6.02441 9.235V10.6518C6.02441 10.7822 6.13013 10.8879 6.26054 10.8879H12.3357C12.4661 10.8879 12.5718 10.7822 12.5718 10.6518V9.235C12.5718 9.10459 12.4661 8.99887 12.3357 8.99887Z"
      fill="currentColor"
    />
    <path
      d="M14.1815 16.4388C14.1815 16.256 14.0337 16.1082 13.8509 16.1082H12.6762C12.6213 16.1082 12.5689 16.1308 12.5311 16.1706L11.1189 17.6601C10.9981 17.7876 11.0884 17.9977 11.264 17.9977H13.8509C14.0337 17.9977 14.1815 17.8494 14.1815 17.6667V16.4388Z"
      fill="currentColor"
    />
    <path
      d="M16.6587 17.9977H13.828C13.6452 17.9977 13.4974 17.8499 13.4974 17.6672V16.4393C13.4974 16.2565 13.6452 16.1087 13.828 16.1087H14.7697C14.9525 16.1087 15.1003 15.9609 15.1003 15.7781V7.4919C15.1003 7.40548 15.0663 7.32236 15.0058 7.26049L9.83507 1.98868C9.77273 1.9254 9.68772 1.8895 9.59894 1.8895H4.91981C4.73704 1.8895 4.58923 2.03732 4.58923 2.22008V6.94739C4.58923 7.13015 4.44141 7.27797 4.25865 7.27797H3.03078C2.84801 7.27797 2.7002 7.13015 2.7002 6.94739V0.33058C2.7002 0.147817 2.84801 0 3.03078 0H10.3923C10.4811 0 10.5661 0.0358917 10.6285 0.0991743L16.8948 6.48835C16.9553 6.55022 16.9893 6.63333 16.9893 6.71976V17.6667C16.9893 17.8495 16.8415 17.9973 16.6587 17.9973V17.9977Z"
      fill="currentColor"
    />
    <path
      d="M0.0993856 16.0211L0.991179 15.1181C1.12392 14.9836 1.33864 14.9836 1.47138 15.1181L3.4491 17.1207C3.58184 17.2551 3.79656 17.2551 3.9293 17.1207L5.90736 15.1177C6.0401 14.9833 6.25482 14.9833 6.38756 15.1177L7.27935 16.0207C7.41209 16.1551 7.41209 16.3725 7.27935 16.507L3.9293 19.8992C3.79656 20.0336 3.58184 20.0336 3.4491 19.8992L0.0993856 16.5073C-0.0333544 16.3729 -0.0333544 16.1555 0.0993856 16.0211Z"
      fill="currentColor"
    />
    <path
      d="M4.65959 17.9202L4.65959 12.0423C4.65959 11.8524 4.50756 11.6985 4.32004 11.6985L3.05885 11.6985C2.87132 11.6985 2.7193 11.8524 2.7193 12.0423L2.7193 17.9202C2.7193 18.1101 2.87132 18.264 3.05885 18.264L4.32004 18.264C4.50757 18.264 4.65959 18.1101 4.65959 17.9202Z"
      fill="currentColor"
    />
  </Icon>
);
